// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { MAP_BRANCH } from 'hfty-map-dom'
import { ACTIVE_TOOLS_OP } from '../constants'

// Local Selectors
export default traverse([MAP_BRANCH, ACTIVE_TOOLS_OP, Boolean])
